import { ConsoleLogger } from '@aws-amplify/core';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const logger = new ConsoleLogger('Storage');

export { logger };
//# sourceMappingURL=logger.mjs.map
